// La preferencia de la barra lateral (ancha o compacta) la recuerda el
// navegador en localStorage: un valor de dos, nunca datos ni tokens. Es la
// misma excepcion documentada que el sidebar de la consola
// (apps/admin/src/ui/Sidebar.tsx) y el silencio del aviso de oferta
// (offer-alert/offerAlertState.ts); esta en eslint.config.js. Sin storage (modo
// privado, cuota llena) el portal anda igual: la preferencia vive mientras la
// pagina esta abierta.
import { parseNavPreference, type NavPreference } from "../logic/navigation.js";

const NAV_KEY = "ucorp.portal.nav";

export function readNavPreference(): NavPreference | null {
  try {
    return parseNavPreference(window.localStorage.getItem(NAV_KEY));
  } catch {
    return null;
  }
}

export function writeNavPreference(preference: NavPreference): void {
  try {
    window.localStorage.setItem(NAV_KEY, preference);
  } catch {
    // Sin storage no hay nada que recordar; la preferencia vive en memoria.
  }
}
